import { Logger } from "@rogoag/shared-ts";
import { env } from "@infra/config/env";

export const logger = new Logger({
	application: "Portal Web",
	entrypoint: "logger.ts",
	isProduction: env.isProduction || env.isDevSentry,
	enableConsoleLogging: env.isDevelopment,
	verboseConsole: env.debug,
	enableSentryLogging: env.isProduction || env.isDevSentry,
});

if (env.debug) logger.log("Logger initialized");
